import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import HolographicBg from "@/components/HolographicBg";
import TopBar from "@/components/TopBar";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function GuestList() {
  const { eventId } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ full_name: "", email: "", occupation: "", instagram_handle: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) setForm((f) => ({ ...f, full_name: user.full_name || "", email: user.email || "" }));
  }, [user]);

  if (!user) { navigate(`/login?redirect=/guest-list/${eventId}`); return null; }

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data: gl } = await api.post("/guest-list", { ...form, event_id: eventId });
      const { data: co } = await api.post("/checkout/ticket", { event_id: eventId, origin_url: window.location.origin, guest_list_id: gl.id });
      if (co.free) { navigate("/access-granted?type=ticket&free=1"); return; }
      window.location.href = co.url;
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed");
      setLoading(false);
    }
  };

  return (
    <div className="relative min-h-screen">
      <HolographicBg />
      <TopBar />
      <main className="relative z-20 flex items-center justify-center px-6 py-16">
        <div className="glass-strong rounded-sm p-10 w-full max-w-lg">
          <div className="font-mono text-[10px] tracking-[0.4em] uppercase text-cyan-400/80">— curation —</div>
          <h1 className="font-display text-3xl font-black uppercase mt-2">Guest List Application</h1>
          <p className="font-mono text-xs uppercase tracking-widest text-white/60 mt-3">
            We curate every attendee. Be precise.
          </p>
          <form onSubmit={submit} className="mt-8 space-y-4">
            <input required value={form.full_name} onChange={set("full_name")} placeholder="Full name (matches ID)" data-testid="guest-name" className="w-full px-4 py-3 bg-black/60 border border-white/15 rounded-sm font-mono text-sm focus:outline-none focus:border-cyan-400/80" />
            <input type="email" required value={form.email} onChange={set("email")} placeholder="Email" data-testid="guest-email" className="w-full px-4 py-3 bg-black/60 border border-white/15 rounded-sm font-mono text-sm focus:outline-none focus:border-cyan-400/80" />
            <input required value={form.occupation} onChange={set("occupation")} placeholder="What do you do?" data-testid="guest-occupation" className="w-full px-4 py-3 bg-black/60 border border-white/15 rounded-sm font-mono text-sm focus:outline-none focus:border-cyan-400/80" />
            <input value={form.instagram_handle} onChange={set("instagram_handle")} placeholder="@instagram (optional)" data-testid="guest-ig" className="w-full px-4 py-3 bg-black/60 border border-white/15 rounded-sm font-mono text-sm focus:outline-none focus:border-cyan-400/80" />
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/40 leading-relaxed">
              Entry requires two pieces of valid government ID matching this form. No exceptions.
            </div>
            <button type="submit" disabled={loading} data-testid="guest-submit" className="gate w-full py-3 bg-white text-black font-display font-bold uppercase tracking-[0.3em] text-xs rounded-sm hover:scale-[1.02] transition">
              {loading ? "Submitting..." : "Submit & Pay"}
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}
